import { render, staticRenderFns } from "./BasalsTableV2.vue?vue&type=template&id=1e97b8dc&scoped=true"
import script from "./BasalsTableV2.vue?vue&type=script&lang=js"
export * from "./BasalsTableV2.vue?vue&type=script&lang=js"
import style0 from "./BasalsTableV2.vue?vue&type=style&index=0&id=1e97b8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e97b8dc",
  null
  
)

export default component.exports